import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Typography } from 'wtb-components';
import { useTransactionContext } from 'context';
import { isEmail } from 'utils';
import clsx from 'clsx';
import styles from './ContactMessage.module.css';

const ContactMessage = ({ className, hideEmail, center = false }) => {

  const { t: translate } = useTranslation();
  const { campaign: { email } } = useTransactionContext();

  return email && !hideEmail
    ? (
      <Typography
        id="merchant-contact-message"
        className={clsx(styles.root, className)}
        component="div"
        variant="body2"
        align={center ? 'center' : 'left'}
      >
        <Trans
          i18nKey="finish.success.info"
          values={{ email }}
          components={[
            <Typography
              className={styles.link}
              component="a"
              variant="body2"
              align="center"
              href={isEmail(email) ? `mailto:${email}` : email}
            />
          ]}
        />
      </Typography>
    ) : (
      <Typography
        id="merchant-contact-message"
        className={clsx(styles.root, className)}
        component="div"
        variant="body2"
        align={center ? 'center' : 'left'}
      >
        {translate('finish.info.generic')}
      </Typography>
    );
};

export default ContactMessage;
